import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import Loader from "react-spinner-loader";
import {
  Editicon,
  Deleteicon,
  Viewicon,
  UploadCloud,
  Reload
  // Replaceicon
} from "../../../../Components/IconComponents";
import Table from "../../../../Components/UiComponents/Table/Table";
//import { Modal, Button } from "react-bootstrap";
import {
  contactTableData,
  userTableDatacolumnsForExport,
} from "../../../../JsonData/ContactConfig";
import {
  getUsersFromApp,
  deleteContactURL,
  deleteUserById,
  getResourceDeploy,
  getReleaseResourceDeploy
} from "../../../../Services/EndPoints";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { getData, putDataWithBody } from "../../../../Services/Services";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import { useTranslation } from "react-i18next";
import { RoleContext } from "../../../..";
import Moment from "react-moment";
import { Modal, Button } from "react-bootstrap";
import Expandaletable from "../../../../Components/UiComponents/Table/ExpandableTable";
import ExecuteSopsExpandableTable from "../../SOPManagement/ExecuteSopsForm/ExecuteSopsExpandableTable";
import DeploymentListExpandableTable from "./DeploymentListExpandableTable";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import ExcelJS from "exceljs";

// const ResourceReleaseIconOpen = ({ className, onClick }) => (
//   <svg
//     className={className}
//     onClick={onClick}
//     width="19"
//     height="19"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     style={{ cursor: 'pointer' }}
//   >
//     {/* Open shackle to the left */}
//     <path
//       d="M17 11V7a5 5 0 00-9.9-1" // flipped shackle arc
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
    
//     {/* Lock body */}
//     <rect
//       x="4"
//       y="11"
//       width="16"
//       height="10"
//       rx="2"
//       stroke="currentColor"
//       strokeWidth="2"
//     />
    
//     {/* Keyhole */}
//     <circle cx="12" cy="16" r="1" fill="currentColor" />
//   </svg>
// );

const ResourceReleaseIconOpen = ({ className, onClick }) => (
  <svg
    className={className}
    onClick={onClick}
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: 'pointer' }}
  >
    {/* Completely open shackle - detached U-shape to the left */}
    <path
      d="M2 8V6a4 4 0 018 0v2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    
    {/* Lock body */}
    <rect
      x="4"
      y="11"
      width="16"
      height="10"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    
    {/* Keyhole */}
    <circle cx="12" cy="16" r="1" fill="currentColor" />
  </svg>
);

const ResourceReleaseIconClose = ({ className, onClick }) => (
  <svg
    className={className}
    onClick={onClick}
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: 'pointer' }}
  >
    {/* Closed shackle */}
    <path
      d="M8 11V7a4 4 0 118 0v4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    
    {/* Lock body */}
    <rect
      x="4"
      y="11"
      width="16"
      height="10"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    
    {/* Keyhole */}
    <circle cx="12" cy="16" r="1" fill="currentColor" />
  </svg>
);


const DeploymentList = forwardRef((props, ref) => {
  const { roleName } = useContext(RoleContext);
  const dispatch = useDispatch();
  const qs = require("qs");
  const [userData, setUserData] = useState(contactTableData);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const { t, i18n } = useTranslation();
  const [searchData, setSearchData] = useState([]);
  const [ResourceData, setResourceData] = useState([]);
  const [showReleaseModal, setShowReleaseModal] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);

  console.log(searchData,"searchuserdata");


const getResourceDeployList = async () => {
  try {
    setLoader(true);
    const viewData = await getData(getResourceDeploy);
    const processedData = viewData
      .map((item, index) => {
        // Get all unique incident names
        const incidentNames = [...new Set(
          (item.deployed_resource_list || [])
            .filter(d => d.incident_name)
            .map(d => d.incident_name)
        )].join(", ");
        
        return {
          ...item,
          id: index,
          incident_name: incidentNames || "NA", // Add incident_name at resource level
          deployedResourceList: (item.deployed_resource_list || [])
            .sort((a, b) => new Date(b.deployed_date_and_time) - new Date(a.deployed_date_and_time))
        };
      })
      .sort((a, b) => {
        const getLatestDate = (resource) => {
          if (!resource.deployedResourceList || resource.deployedResourceList.length === 0) return 0;
          return Math.max(...resource.deployedResourceList.map(d => new Date(d.deployed_date_and_time)));
        };
        return getLatestDate(b) - getLatestDate(a);
      });
        
    setResourceData(processedData);
  } catch (error) {
    console.error("Error fetching resource data:", error);
    toast.error("Failed to fetch resource data", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  } finally {
    setLoader(false);
  }
};

  useEffect(() => {
    getResourceDeployList();
  }, []);



const handleReplaceClick = (resource) => {
    setSelectedResource(resource);
    setShowReleaseModal(true);
  };

const handleRelease = async () => {
  try {
    setLoader(true);

    const deployedResources = selectedResource.deployed_resource_list || [];
    const deployedResourcesOnly = deployedResources.filter(item => item.is_deployed);

    const requestData = deployedResourcesOnly.map(deployedItem => ({
      resourceId: selectedResource.resource_id,
      id: deployedItem.id
    }));

    if (requestData.length === 0) {
      toast.error("No deployed resources found to release", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      setLoader(false);
      return;
    }

    const response = await putDataWithBody(getReleaseResourceDeploy, requestData, {});

    if (response.status === "success" || response.status === "multi-status") {
      const allSuccessful = response.results?.every(r => r.status === "success");
      if (allSuccessful) {
        toast.success("Resource(s) released successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      } else {
        const failed = response.results?.filter(r => r.status !== "success");
        toast.error(`Some resources failed to release: ${failed.map(f => f.msg).join(', ')}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
      getResourceDeployList();
    } else {
      toast.error(response.msg || "Failed to release resource", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  } catch (error) {
    console.error("Error releasing resource:", error);
    toast.error("An error occurred while releasing the resource", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  } finally {
    setLoader(false);
    setShowReleaseModal(false);
  }
};

const handleDownload = async () => {
  try {
    setLoader(true);
    
    // Create a new workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Deployment List');

    // Define columns
    worksheet.columns = [
      { header: 'Incident Name', key: 'incidentName', width: 40 },
      { header: 'Resource Name', key: 'resourceName', width: 40 },
      { header: 'Agency Name', key: 'resourceAgencyName', width: 50 },
      { header: 'Region Name', key: 'regionName', width: 20 },
      { header: 'Resource Facility Name', key: 'resourceFacilityName', width: 40 },
      { header: 'Available Quantity', key: 'availableQuantity', width: 18 },
      { header: 'Deployed Quantity', key: 'deployedQuantity', width: 18 },
      { header: 'Deployed Facility Name', key: 'deployFacilityName', width: 40 },
      { header: 'Deployed Quantity', key: 'deployQuantity', width: 18 },
      { header: 'Deployed Date and Time', key: 'deployedDate', width: 30 },
      { header: 'Released Date and Time', key: 'releasedDate', width: 30 },
      { header: 'Deployed By', key: 'deployedBy', width: 25 },
      { header: 'Released By', key: 'releasedBy', width: 25 },
      { header: 'Status', key: 'status', width: 15 }
    ];

    // Function to format date to 12-hour format
    const formatTo12Hour = (dateString) => {
      if (!dateString || dateString === 'N/A') return dateString;
      
      try {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      } catch (e) {
        console.error('Error formatting date:', e);
        return dateString;
      }
    };

    // Add data rows
    ResourceData.forEach(resource => {
      const deployedResources = resource.deployed_resource_list || [];
      const totalDeployedQuantity = deployedResources
        .filter(item => item.is_deployed)
        .reduce((sum, item) => sum + (item.deploy_quantity || 0), 0);

      // If no deployed resources, add just the parent row
      if (deployedResources.length === 0) {
        worksheet.addRow({
          incidentName: resource.incident_name || "N/A",
          resourceName: resource.resource_name,
          resourceAgencyName: resource.resource_agency_name,
          regionName: resource.resource_region_name,
          resourceFacilityName: resource.resource_facility_name,
          availableQuantity: resource.available_quantity,
          deployedQuantity: totalDeployedQuantity
        });
      } else {
        // Add a row for each deployed resource with full parent data
        deployedResources.forEach((deployed) => {
          worksheet.addRow({
            incidentName: deployed.incident_name || resource.incident_name || "N/A",
            resourceName: resource.resource_name,
            resourceAgencyName: resource.resource_agency_name,
            regionName: resource.resource_region_name,
            resourceFacilityName: resource.resource_facility_name,
            availableQuantity: resource.available_quantity,
            deployedQuantity: totalDeployedQuantity,
            deployFacilityName: deployed.deploy_facility_name,
            deployQuantity: deployed.deploy_quantity,
            deployedDate: formatTo12Hour(deployed.deployed_date_and_time),
            releasedDate: formatTo12Hour(deployed.released_date_and_time) || 'N/A',
            deployedBy: deployed.deployed_by,
            releasedBy: deployed.released_by || 'N/A',
            status: deployed.is_deployed ? 'Deployed' : 'Released'
          });
        });
      }
    });

    // Auto-filter
    worksheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: worksheet.columns.length }
    };

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Resource_Deployment_List.xlsx';
    a.click();
    URL.revokeObjectURL(url);

  } catch (error) {
    console.error('Error generating Excel:', error);
    toast.error('Failed to generate Excel file', {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  } finally {
    setLoader(false);
  }
};

  const handleCancel = () => {
    setShowReleaseModal(false);
  };

  const addNewHandler = () => {
    navigate("/users/create-user");
  };

  const getShortenedText = (strLength, fulltext) => {
    let abbreviatedText = "";
    if (fulltext.length > strLength) {
      abbreviatedText = fulltext.substring(0, 15) + "...";
    } else {
      abbreviatedText = fulltext;
    }
    return <span title={fulltext}>{abbreviatedText}</span>;
  };
  // const getUserList = async () => {
  //   setLoader(true);
  //   var userList = await getData(getUsersFromApp);
  //   setLoader(false);
  //   userList.forEach(value => {
  //     // user_role_map
  //     value.user_role_map_forSearch = value.user_role_map?.map(role => role.roleEntity.name).join(", ") || "NA";
  //   })
  //   console.log('ssss',userList);
  //   setUserData(userList);
  //   setRowCount(userList.length);
  // };
  //   useEffect(() => {
  //     if (props.locationInstance && props.locationInstance.msg != "") {
  //       toast.success("Agency has been created successfully.", {
  //         position: toast.POSITION.TOP_CENTER,
  //         autoClose: 2000, // Close after 2 seconds
  //       });
  //     }
  //     getAgecnyList();
  //   }, []);

  const sendDataToCentralStore = (data) => {
    console.log(data, "USERDATA");
    if (data.length > 0) {
      const columns = userTableDatacolumnsForExport;
  
      const processedData = data.map((item) => ({
        ...item,
        full_name: `${item.first_name || ""} ${item.last_name || ""}`.trim(),
        // Format the createdOn date as DD/MM/YYYY, HH:mm
        createdOn: item.createdOn
          ? new Date(item.createdOn).toLocaleDateString('en-GB') + ', ' + new Date(item.createdOn).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
          : "NA",
      }));
  
      console.log("PRdataForuser",processedData);
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, processedData),
        })
      );
    }
  };
  
 const columns = React.useMemo(
  () => [
    {
      Header: t("resourceallocationlistheaders.incidentname"),
      accessor: "incident_name",
      disableSortBy: true,
    },
    {
      Header: t("resourceallocationlistheaders.rname"),
      accessor: "resource_name",
      disableSortBy: true,
    },
    {
      Header: t("resourceallocationlistheaders.raname"),
      accessor: "resource_agency_name",
      disableSortBy: true,
    },
    {
      Header: t("resourceallocationlistheaders.bname"),
      accessor: "resource_region_name",
      disableSortBy: true,
    },
    {
      Header: t("resourceallocationlistheaders.rfname"),
      accessor: "resource_facility_name",
      disableSortBy: true,
    },
     {
       Header: () => (
         <div className="text-center">
           {t("resourceallocationlistheaders.aquantity")}
         </div>
       ),
       accessor: "available_quantity",
       disableSortBy: true,
       Cell: ({ value }) => <div style={{ textAlign: 'center' }}>{value}</div>,
     },
     {
       Header: () => (
         <div className="text-center">
           {t("resourceallocationlistheaders.quantity")}
         </div>
       ),
       accessor: "deployed_resource_list",
       disableSortBy: true,
       Cell: ({ value }) => {
         // Filter items where is_deployed is true and sum their deploy_quantity
         const totalQuantity = value
           ?.filter(item => item.is_deployed === true)
           .reduce((sum, item) => sum + (item.deploy_quantity || 0), 0) || 0;
         return <div style={{ textAlign: 'center' }}>{totalQuantity}</div>;
       }
     },
     {
       Header: t("resourceallocationlistheaders.action"),
       disableSortBy: true,
       Cell: (props) => {
         const hasDeployedResources = props.row.original.deployed_resource_list?.some(item => item.is_deployed) || false;

         const releaseAllTooltip = (
           <Tooltip id="release-all-tooltip">
             Released All Resources
           </Tooltip>
         );

         const deployedTooltip = (
           <Tooltip id="deployed-tooltip">
             Deployed Resources (Click to Release All)
           </Tooltip>
         );

         if (hasDeployedResources) {
           return (
             <div className="usertable__actionsicon">
               <OverlayTrigger placement="top" overlay={deployedTooltip}>
                 <span onClick={() => handleReplaceClick(props.row.original)}>
                   <ResourceReleaseIconClose className="cursor-pointer ms-3" />
                 </span>
               </OverlayTrigger>
             </div>
           );
         }
         return (
           <div className="usertable__actionsicon">
             <OverlayTrigger placement="top" overlay={releaseAllTooltip}>
               <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                 <ResourceReleaseIconOpen className="ms-3" />
               </span>
             </OverlayTrigger>
           </div>
         );
       },
     },
  ],
  [t, roleName]
);

const handleResourceReleaseFromExpandedTable = async (resourceData) => {
  try {
    setLoader(true);
    
    // Prepare the request data
    const requestData = [{
      resourceId: resourceData.resource_id,
      id: resourceData.selectedDeployment?.id || resourceData.id
    }];
    
    // Call the release endpoint
    const response = await putDataWithBody(getReleaseResourceDeploy, requestData, {});
    
    if (response.status === "success") {
      toast.success("Resource released successfully", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      
      // Force a refresh of the table data
      await getResourceDeployList();
    } else {
      toast.error(response.msg || "Failed to release resource", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  } catch (error) {
    console.error("Error releasing resource:", error);
    toast.error("An error occurred while releasing the resource", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  } finally {
    setLoader(false);
  }
};

  console.log(userData,"userdata");
  return (
    <div className="create-user">
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      {/* <div className="d-flex justify-content-end mt-0 mb-0" style={{ marginRight: "230px", position: "relative", zIndex: 10, }}>
        <button
          className="btn btn-success btn-sm flood__report--button"
          onClick={handleDownload}
        >
          Download
        </button>
      </div> */}
      {/* <div className="d-flex justify-content-end mt-0 mb-0" style={{ marginRight: "230px", position: "relative", zIndex: 10, }}>
        <button
          className="btn btn-success btn-sm flood__report--button"
          onClick={handleDownload}
        >
          Download
        </button>
      </div> */}
      <div className="datatable__container" style={{marginTop:"0px"}}>
          {/* <Table */}
          <DeploymentListExpandableTable
            data={ResourceData}
            columns={columns}
            numberOfRows={10}
            setSearchData={setSearchData}
            addButtonLabel={t("Download")}
            addNewHandler={handleDownload}
            showExport={false}
            showFilter={false}
            showReset={false}
            onExpand={false}
            rowCount={rowCount} // Pass rowCount to the Table component
            headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF", verticalAlign:"top" }}
            tableStyle={{
              border: "1px solid  #f0f0f0",
              borderRadius: "12px",
            }}
          onResourceRelease={handleResourceReleaseFromExpandedTable}
          onDataRefresh={getResourceDeployList}
          loader={loader}
          onExport={handleDownload}
          />

      </div>
    <Modal show={showReleaseModal} onHide={handleCancel} style={{ marginTop: '6rem'}} dialogClassName="custom-modal-width">      
        {/* <Modal.Header closeButton>
          <Modal.Title>Release Resource</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          Are you sure you want to release the resources?
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <div className="d-flex gap-2" style={{marginTop:"-2rem"}}>
            <Button className="btn-cancel" onClick={handleCancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleRelease}>
              Release
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
});

export default DeploymentList;
